import { useRef, useEffect } from 'react';
import { isNotNil } from '@wistia/type-guards';

// this hook will focus on a referenced element when the component using it mounts (or when the
// ref changes) and then attempts to restore the previously focused element when the component
// unmounts (or when the ref changes again)
export const useFocusRestore = () => {
  // for tracking the element that was focused before we mounted
  const previouslyFocusedRef = useRef<HTMLElement | null>(null);

  // save the currently focused element on initial mount
  useEffect(() => {
    previouslyFocusedRef.current = document.activeElement as HTMLElement | null;
  }, []);

  // on unmount, restore focus to the previously focused element
  useEffect(() => {
    return () => {
      if (isNotNil(previouslyFocusedRef.current)) {
        // give unmounting a moment before focusing
        setTimeout(() => {
          previouslyFocusedRef.current?.focus();
        }, 0);
      }
    };
  }, []);
};
